<script>
import { layoutComputed } from "@/state/helpers";

import Topbar from "@/components/topbar";
import Rightsidebar from "@/components/right-sidebar";
// import HorizontalNav from "@/components/horizontal-nav";

/**
 * Horizontal-layout
 */
export default {
  computed: {
    ...layoutComputed,
  },
  mounted() {
    document.body.setAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-sidebar");
  },
  components: {
    Topbar,
    Rightsidebar
  },
  methods: {
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
  },
  data(){
    return {
      clearSpacesPages: ['browse-space','browse-space-details']
    }
  },
};
</script>

<template>
  <!-- Begin page -->
  <div id="layout-wrapper">
    <header id="page-topbar" class="header-shadow">
      <Topbar :type="topbar" :layoutscroll="layoutScrollable" />
      <!-- <HorizontalNav :width="layoutWidth" /> -->
    </header>
    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content" id="mainContent">
      <div class="page-content" :class="{ 'p-0': clearSpacesPages.includes(this.$route.name) }">
        <div :class="{ 'container-fluid': !clearSpacesPages.includes(this.$route.name) }">
          <slot />
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->
    </div>
    <!-- end main content-->
    <Rightsidebar />
  </div>
</template>


<style scoped>
  .header-shadow {
    box-shadow: 0px 8px 16px 0px #00000026 !important;
  }
</style>